export const MEMOIZE_DUMMY_RESOLVER = (...args) => args[0];
export const MEMOIZE_SESSION_TIMEOUT = 1000 * 60 * 5;
export const ETH_NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ZERO_ALLOWANCE_ASSETS = ['USDT', 'ANTv1', 'BNT', 'SNT', 'MANA', 'DENT', 'LDO'];
export const ALLOWED_AMOUNTS_DIFF_PERCENTAGE = 10;
